<template>
  <div class="mx-5 mx-md-16 px-md-16">
    <v-data-table
      :headers="headers"
      :items="rows.items"
      :items-per-page="-1"
      hide-default-footer
      disable-sort
      class="elevation-1 rounded-lg"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="activeUser(item)"
          ><v-icon small color="success">fa-sync-alt</v-icon></v-btn
        >
      </template>
    </v-data-table>
    <div class="pt-2 d-flex flex-column flex-md-row align-center justify-end">
      <span class="font-quicksand">Filas por páginas: </span>
      <span style="width: 50px" class="mx-md-2">
        <v-select
          v-model="itemsPerPage"
          :items="itemsPerPages"
          class="font-quicksand"
          @change="onItemsPerPageChange"
        ></v-select>
      </span>
      <span class="font-quicksand"
        >{{ rowsRangeStart }}-{{ rowsRangeEnd }} de {{ rows.totalItems }}
      </span>
      <v-pagination
        v-model="page"
        :length="rows.totalPages"
        :total-visible="pageVisible"
        color="red"
        class="font-work-sans"
        @input="onPageChange"
      ></v-pagination>
    </div>

    <dialog-patient
      :patient="patient"
      :del="del"
      :dialog="dialog"
      @dismiss="
        () => {
          dialog = false
          loadData()
        }
      "
    />
  </div>
</template>

<script>
import Repository from '@/repositories/RepositoryFactory'
import { createPaginationMixin } from '@/mixins/pagination'
const PatientRepository = Repository.get('patients')
import DialogPatient from './Dialog.vue'

export default {
  components: { DialogPatient },
  name: 'InactivePatients',
  props: ['search'],
  mixins: [createPaginationMixin({ debounceMs: 500 })],
  data: () => ({
    headers: [
      {
        text: 'Cédula',
        align: 'center',
        class:
          'primary white--text rounded-tl-lg font-weight-bold text-subtitle-2',
        value: 'idNumber',
      },
      {
        text: 'Nombre',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'firstName',
      },
      {
        text: 'Apellido',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'lastName',
      },
      {
        text: 'Teléfono',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'cellphone',
      },
      {
        text: 'Opciones',
        align: 'center',
        class:
          'primary white--text rounded-tr-lg font-weight-bold text-subtitle-2',
        value: 'actions',
      },
    ],
    itemsPerPages: [10, 20, 30, 50, 100],
    del: false,
    patient: null,
    dialog: false,
  }),
  methods: {
    activeUser: function (item) {
      this.patient = item
      this.dialog = true
    },
    fetchPage: function (params) {
      return PatientRepository.getDeleted(params)
    },
  },
}
</script>
